import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ApvConfigService } from '../../core/services/firestore/apv-config.service';
import { IFundOption, MULTI_FUNDS } from '../constants/regime-fund.constant';
import { toGenerationalFunds } from '../mappers/fund.mapper';

@Injectable({ providedIn: 'root' })
export class FundCatalogService {
  private readonly generationalFunds$: Observable<IFundOption[]>;

  constructor(apvConfigSvc: ApvConfigService) {
    this.generationalFunds$ = apvConfigSvc.fundNames().pipe(
      map(toGenerationalFunds),
      shareReplay(1)
    );
  }

  generationalFunds(): Observable<IFundOption[]> {
    return this.generationalFunds$;
  }

  fundName(fundId: string | undefined): Observable<string> {
    return this.generationalFunds$.pipe(
      map(
        (generationalFunds) =>
          [...generationalFunds, ...MULTI_FUNDS].find(
            (fund) => fund.id === fundId
          )?.name ??
          fundId ??
          ''
      )
    );
  }
}
